import { eventListenerOptions } from '@spinnwerk/polyfills';

/**
 * Should not be called directly.
 * @see {@link loadingIndicator}
 *
 * @param {NodeList|HTMLElement} forms
 * @param {object} [options]
 * @param {string} [options.loadingClass]
 * @param {string} [options.exclude]
 * @param {string} [options.prepend]
 * @param {string} [options.append]
 * @private
 */
export function initIndicator(
    forms,
    {
        loadingClass = 'is-loading',
        exclude = '',
        prepend = '',
        append = `<span class="button__loading-indicator">
    <span class="loading-indicator-item"></span>
    </span>`,
    } = {},
) {
    const addIndicator = form => {
        let formSubmitSelector = '[type="submit"]:not([target="_blank"])',
            formSubmit;

        // exclude submit buttons, if configured
        formSubmit = Array.prototype.filter.call(form.querySelectorAll(formSubmitSelector) || [], submit =>
            exclude ? submit.matches(exclude) !== true : true,
        );

        formSubmit.forEach(submit => {
            if (submit.hasAttribute('aria-live') === false) {
                submit.setAttribute('aria-live', 'assertive');
            }

            submit.addEventListener(
                'click',
                event => {
                    event.currentTarget.classList.add('submitter');
                },
                eventListenerOptions({ passive: true }),
            );
        });

        form.addEventListener(
            'submit',
            () => {
                if (formSubmit.length === 0) {
                    return;
                }

                let submitter = form.querySelector('.submitter');

                if (submitter) {
                    submitter.classList.remove('submitter');
                } else {
                    submitter = formSubmit[formSubmit.length - 1];
                }

                if (submitter.matches('input')) {
                    // wrap it, so e.g. hover effects of the input can also effect the indicator
                    let container = document.createElement('span'),
                        nextElement = submitter.nextElementSibling;

                    container.classList.add('loading-indicator-container');
                    submitter.insertAdjacentElement('beforebegin', container);
                    container.appendChild(submitter);

                    // input[type="submit"] cannot contain child elements
                    // so the loading indicator is displayed besides the input
                    if (nextElement === null || nextElement.matches('.loading-indicator') === false) {
                        let newSubmitter = document.createElement('span');

                        newSubmitter.classList.add('loading-indicator');
                        newSubmitter.insertAfter(submitter);
                        submitter = newSubmitter;
                    } else {
                        submitter = nextElement;
                    }
                }

                if (!submitter.dataset.loadingInitialized) {
                    // add our pre- and append html if not already happened
                    submitter.dataset.loadingInitialized = true;

                    submitter.insertAdjacentHTML('afterbegin', prepend);
                    submitter.insertAdjacentHTML('beforeend', append);
                }

                // add a loading indicator to the submit
                submitter.classList.add(loadingClass);
            },
            eventListenerOptions({ passive: true }),
        );
    };

    if (forms instanceof NodeList) {
        forms.forEach(form => {
            addIndicator(form);
        });
    } else {
        addIndicator(forms);
    }
}
